import React, { useState } from "react";
import { FaChevronDown } from "react-icons/fa";
import { Link } from "react-router-dom";
import contentConfig from "../content.config.json";
import "../Styles/Faqs.css";

const Faqs = () => {
  const { title, subtitle, items } = contentConfig.faqs;
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faqs-page">
      <div className="banner">
        <div className="banner-overlay">{title}</div>
      </div>

      <div className="faqs-container">
        <div className="faqs-intro">
          <p>{subtitle}</p>
        </div>

        <div className="faqs-list">
          {items.map((faq, index) => (
            <div
              key={index}
              className={`faq-item ${openIndex === index ? "faq-item--open" : ""}`}
            >
              <button
                className="faq-question"
                onClick={() => toggleFaq(index)}
                aria-expanded={openIndex === index}
              >
                <span>{faq.question}</span>
                <FaChevronDown className="faq-icon" />
              </button>
              <div className="faq-answer">
                <p>
                  {faq.answer.includes("Contact Us") ? (
                    <>
                      {faq.answer.split("Contact Us")[0]}
                      <Link to="/contact" className="faq-link">
                        Contact Us
                      </Link>
                      {faq.answer.split("Contact Us")[1]}
                    </>
                  ) : (
                    faq.answer
                  )}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Faqs;